export default __webpack_public_path__ + "static/acc-opening-banner-mobile-f710d066a019e9017ed2509a6d68dc1e.jpg";